var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 7.77083C1.375 7.3129 1.74987 6.9375 2.21433 6.9375H7.53567C8.00082 6.9375 8.375 7.31094 8.375 7.77483V10.7348C8.375 10.9599 8.17089 11.2706 7.44807 11.5441C6.77241 11.7997 5.83706 11.9373 4.875 11.9373C3.91294 11.9373 2.97759 11.7997 2.30193 11.5441C1.57911 11.2706 1.375 10.9599 1.375 10.7348V7.77083ZM7.04167 3.10417C7.04167 4.30078 6.07162 5.27083 4.875 5.27083C3.67838 5.27083 2.70833 4.30078 2.70833 3.10417C2.70833 1.90755 3.67838 0.9375 4.875 0.9375C6.07162 0.9375 7.04167 1.90755 7.04167 3.10417Z",
    stroke: "#8993A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.739f439b.svg";
export { ForwardRef as ReactComponent };